export default __webpack_public_path__ + "static/sample-size-determination-dark-f643de22e156c1ee2ad3d232d277e2bc.png";